var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlind1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 44,
    viewBox: "0 0 41 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.013 28.9564C39.013 28.4881 38.6309 28.106 38.1626 28.106C37.6944 28.106 37.3123 28.4881 37.3123 28.9564C37.3123 29.4251 37.6944 29.8071 38.1626 29.8071C38.6309 29.8071 39.013 29.4251 39.013 28.9564Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.013 32.358C39.013 31.8897 38.6309 31.5076 38.1626 31.5076C37.6944 31.5076 37.3123 31.8897 37.3123 32.358C37.3123 32.8263 37.6944 33.2084 38.1626 33.2084C38.6309 33.2084 39.013 32.8263 39.013 32.358Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.013 8.54662C39.013 8.07834 38.6309 7.69623 38.1626 7.69623C37.6944 7.69623 37.3123 8.07834 37.3123 8.54662C37.3123 9.0149 37.6944 9.39701 38.1626 9.39701C38.6309 9.39701 39.013 9.0149 39.013 8.54662Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.013 25.5549C39.013 25.0866 38.6309 24.7045 38.1626 24.7045C37.6944 24.7045 37.3123 25.0866 37.3123 25.5549C37.3123 26.0236 37.6944 26.4056 38.1626 26.4056C38.6309 26.4056 39.013 26.0236 39.013 25.5549Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.013 22.1533C39.013 21.685 38.6309 21.3029 38.1626 21.3029C37.6944 21.3029 37.3123 21.685 37.3123 22.1533C37.3123 22.622 37.6944 23.004 38.1626 23.004C38.6309 23.004 39.013 22.622 39.013 22.1533Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.013 18.7517C39.013 18.2834 38.6309 17.9013 38.1626 17.9013C37.6944 17.9013 37.3123 18.2834 37.3123 18.7517C37.3123 19.2204 37.6944 19.6024 38.1626 19.6024C38.6309 19.6024 39.013 19.2204 39.013 18.7517Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.013 11.9481C39.013 11.4798 38.6309 11.0977 38.1626 11.0977C37.6944 11.0977 37.3123 11.4798 37.3123 11.9481C37.3123 12.4164 37.6944 12.7985 38.1626 12.7985C38.6309 12.7985 39.013 12.4164 39.013 11.9481Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.013 15.3497C39.013 14.8814 38.6309 14.4993 38.1626 14.4993C37.6944 14.4993 37.3123 14.8814 37.3123 15.3497C37.3123 15.818 37.6944 16.2001 38.1626 16.2001C38.6309 16.2001 39.013 15.818 39.013 15.3497Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1716 37.6981H39.1529V35.4343H37.1716V37.6981Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1592 35.4841C39.1592 35.0422 38.7144 34.6819 38.1683 34.6819C37.6229 34.6819 37.178 35.0422 37.178 35.4841C37.178 35.9259 37.6229 36.2865 38.1683 36.2865C38.7144 36.2865 39.1592 35.9259 39.1592 35.4841Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8882 37.0158H38.4362V36.2376H37.8882V37.0158Z",
    fill: "#FEFEFE",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.650391 1.87764H40.0489V0.947083H0.650391V1.87764Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.650391 4.62536H1.5828V1.87811H0.650391V4.62536Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.650391 5.6693H40.0398V4.62579H0.650391V5.6693Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.041 4.62536H40.0399V1.87811H39.041V4.62536Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.63538 42.3733H3.9794V8.6778H2.63538V42.3733Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8717 42.3825H35.2157V8.68683H33.8717V42.3825Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2244 43.7313V42.387H2.63354V43.7313H35.2244Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91663 4.62536H3.84903V1.87811H2.91663V4.62536Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1877 4.62536H37.1202V1.87811H36.1877V4.62536Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2244 8.68613V7.34174H2.63354V8.68613H35.2244Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35071 7.33265H7.15312V5.66803H6.35071V7.33265Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39648 7.33265H9.19853V5.66803H8.39648V7.33265Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7203 7.33265H32.5224V5.66803H31.7203V7.33265Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5747 7.33265H30.3764V5.66803H29.5747V7.33265Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlind1);
export default __webpack_public_path__ + "static/media/Blind-1.16a466f56ae3e457752cc9d93f23a2f1.svg";
export { ForwardRef as ReactComponent };